import { DataBean } from "../../DataBean";


export class HandedType extends DataBean {


    public async getHandedTypeConstants(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHandedTypeConstants_Number", [args]);
    }

}